export enum CardType {
  Podcast = 'podcast',
  ProgramDemand = 'programDemand',
  ProgramLive = 'programLive',
  Publication = 'publication',
  Segment = 'segment'
}
